import Sites from "./Sites";
export default Sites
